import { createI18n } from 'vue-i18n'
import zhCommon from './locales/zh/common.json'
import viCommon from './locales/vi/common.json'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('tn_lang') || 'vi',
  fallbackLocale: 'vi',
  messages: {
    zh: { common: zhCommon },
    vi: { common: viCommon }
  }
})

export default i18n
